<template>
    <div>
        <div>
            <div class="row">
                <div class="col-md-12">
                    <h4>SALES ACHIEVEMENT</h4>
                </div>
            </div>
            <div class="row mb-3 mx-1">
                <div class="col-md-3 card-red" style="cursor: pointer;" @click="gotoPage('value')">
                    <div class="row">
                        <div class="col-auto pr-0 mt-1">
                            <i class="el-icon-aim icon-size"></i>
                        </div>
                        <div class="col">
                            <span class="font-title">Sales Achievement (%)</span><br>
                            <span class="font-subtitle">YTD {{ titlemonth }} {{ titleyear }}</span>
                        </div>
                    </div>
                    <div class="row h-50 mt-2">
                        <div class="col-md-12 align-self-center align-items-center justify-content-center text-center">
                            <span class="font-number">{{ formatNum(reportdata?.data?.overview?.sales_achievement ?? 0, 2) }} %</span>
                        </div>
                    </div>
                    <Loader v-if="loading.table" />
                </div>
                <div class="col-md-3">
                    <div class="row ms-0">
                        <div class="col-md-12 mb-2 card-blue" style="cursor: pointer;" @click="gotoPage('value')">
                            <div class="mb-0">
                                <div class="row">
                                    <div class="col-md-auto pr-0 mt-1">
                                        <i class="el-icon-data-line icon-size"></i> <i class="fa fa-line-chart icon-size" v-if="false"></i>
                                    </div>
                                    <div class="col">
                                        <span class="font-title">Total Revenue (Jt Rp)</span><br>
                                        <span class="font-subtitle">YTD {{ titlemonth }} {{ titleyear }}</span>
                                        <div class="text-center">
                                            <span class="font-number">{{ formatNum(reportdata?.data?.overview?.total_revenue ?? 0, 2) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Loader v-if="loading.table" />
                        </div>
                    </div>
                    <div class="row ms-0">
                        <div class="col-md-12 card-blue" style="cursor: pointer;" @click="gotoPage('value')">
                            <div class="row">
                                <div class="col-md-auto pr-0 mt-1">
                                    <i class="el-icon-data-line icon-size"></i> <i class="fa fa-line-chart icon-size" v-if="false"></i>
                                </div>
                                <div class="col">
                                    <span class="font-title">Rp {{ formatNum(reportdata?.data?.overview?.left_over_revenue ?? 0, 2) }}</span><br>
                                    <span class="font-subtitle">Leftover Revenue</span>
                                </div>
                            </div>
                            <Loader v-if="loading.table" />
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="row m-0">
                        <div class="col-md-12 mb-2 card-green" style="cursor: pointer;" @click="gotoPage('volume')">
                            <div class="mb-0">
                                <div class="row">
                                    <div class="col-md-auto pr-0 mt-1">
                                        <i class="el-icon-stopwatch icon-size"></i>
                                    </div>
                                    <div class="col">
                                        <span class="font-title">Total Volume (KL)</span><br>
                                        <span class="font-subtitle">YTD {{ titlemonth }} {{ titleyear }}</span>
                                        <div class="text-center">
                                            <span class="font-number">{{ formatNum(reportdata?.data?.overview?.total_volume ?? 0, 2) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Loader v-if="loading.table" />
                        </div>
                    </div>
                    <div class="row m-0">
                        <div class="col-md-12 card-green" style="cursor: pointer;" @click="gotoPage('volume')">
                            <div class="row">
                                <div class="col-md-auto pr-0 mt-1">
                                    <i class="el-icon-stopwatch icon-size"></i>
                                </div>
                                <div class="col">
                                    <span class="font-title">{{ formatNum(reportdata?.data?.overview?.left_over_volume ?? 0, 2) }}</span><br>
                                    <span class="font-subtitle">Leftover Volume</span>
                                </div>
                            </div>
                            <Loader v-if="loading.table" />
                        </div>
                    </div>
                </div>
                <div class="col-md-3 card-cyan" style="cursor: pointer;" @click="gotoPage('spd')">
                    <div class="mb-0">
                        <div class="row">
                            <div class="col-md-auto pr-0 mt-1">
                                <i class="el-icon-coin icon-size"></i>
                            </div>
                            <div class="col">
                                <span class="font-title">Average SPD (KL)</span><br>
                                <span class="font-subtitle">YTD {{ titlemonth }} {{ titleyear }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row h-50 mt-2">
                        <div class="col-md-12 align-self-center align-items-center justify-content-center text-center">
                            <span class="font-number">{{ formatNum(reportdata?.data?.overview?.average_spd ?? 0, 2) }}</span>
                        </div>
                    </div>
                    <Loader v-if="loading.table" />
                </div>
            </div>

            <div class="row">
                <div class="col-md-4 mb-4">
                    <el-card shadow="hover">
                        <div slot="header" class="px-1">
                            <h6 class="text-center m-0">CASH / NON CASH (Jt Rp)</h6>
                        </div>
                        <div class="mt-0 d-flex justify-content-center align-items-center">
                            <PieChart class="mt-0" :data="piechartdata.cashnoncash" :url="''" style="width:80%;" :showlegend="true"/>
                        </div>
                        <Loader v-if="loading.table" />
                    </el-card>
                </div>

                <div class="col-md-4 mb-4">
                    <el-card shadow="hover">
                        <div slot="header" class="px-1">
                            <h6 class="text-center m-0">BUSINESS CONTRIBUTION (Jt Rp)</h6>
                        </div>
                        <div class="mt-0 d-flex justify-content-center align-items-center">
                            <PieChart :data="piechartdata.businesscontribution" :url="''" style="width:80%;" :showlegend="true"/>
                        </div>
                        <Loader v-if="loading.table" />
                    </el-card>
                </div>

                <div class="col-md-4 mb-4">
                    <el-card shadow="hover">
                        <div slot="header" class="px-1">
                            <h6 class="text-center m-0">BBM/K (PSO/NPSO) (KL)</h6>
                        </div>
                        <div class="mt-0 d-flex justify-content-center align-items-center">
                            <PieChart class="mt-0" :data="piechartdata.productgroup" :url="''" style="width:80%;" :showlegend="true" :legendPosition="'bottom'"/>
                        </div>
                        <Loader v-if="loading.table" />
                    </el-card>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
import Fuel from '@/components/page/Fuel.js'
//import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import { Rainbow, FuelColor, AppColors, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import PieChart from '@/components/chart/Pie.js'
//import GaugeChart from '@/components/chart/Gauge.js'
import GaugeChart from '@/views/pages/FuelTracking/Component/Gauge.vue'

import TableSalesValueAchievement from '@/views/pages/FuelTracking/FuelTrackingSales/TableSalesValueAchievement.vue'
import TableSalesVolumeAchievement from '@/views/pages/FuelTracking/FuelTrackingSales/TableSalesVolumeAchievement.vue'
import TableAverageSpd from '@/views/pages/FuelTracking/FuelTrackingSales/TableAverageSpd.vue'

export default {
    extends:Fuel,
	components: {
        Loader,
        //BarChart,
        PieChart,
        //GaugeChart,
        //TableSalesValueAchievement,
        //TableSalesVolumeAchievement,
        ///TableAverageSpd,
    },
    props: {
        intervalDuration: {
            type: Number,
            required: false,
            default: 15,
        },
        autoRequestActive: {
            type: Boolean,
            required: false,
            default: true,
        },
    },

    data() {
		return {
            isChildRoute: false,
            chartcolors: ['#F56C6C','#67C23A','#3C61FF','#F14C5D', '#E6A23C','#8C5CFF'],
            urlRequestParams: Config().apiURL,
            reportdata: [],
            showchart: true,
            barchart: [],

            piechartdata: {
                cashnoncash: [],
                productgroup: [],
                businesscontribution: [],
            },

            barchartdata: {
                yoyrevenue: [],
                yoyvolume: [],
            },

            loading: {
                table: true,
                chart: false,
                isSuccess: true,
            },

            monthBefore: this.getMonthName(Penanggalan().bulan-1),
            year: Penanggalan().tahun,
            month: Penanggalan().bulan,

            titlemonth: this.getMonthName(Penanggalan().bulan),
            titleyear: Penanggalan().tahun,

            stacked : false,
            plantno: this.$route.query.plant ? this.$route.query.plant : '',
			stationid: this.$route.query.station ? this.$route.query.station : '',
			stationtype: this.$route.query.stationtype ? this.$route.query.stationtype : 'SPBU',
			period: this.$route.query.period ? this.$route.query.period : 'monthly',
			area: this.$route.query.area ? this.$route.query.area : 'area',
			owner: this.$route.query.owner ? this.$route.query.owner : '',
			lokasi: this.$route.query.lokasi ? this.$route.query.lokasi : '',
			status: this.$route.query.status ? this.$route.query.status : '',
			satgas: this.$route.query.satgas ? this.$route.query.satgas : '',
            date: {
                Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,
                End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().bulanKemarin,
            },

            dateRange: [this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,this.$route.query.dateEnd ? this.$route.query.dateEnd : this.getLastDayOfMonth(Penanggalan().tahun, (Penanggalan().bulan-1))],

            gaugedata: {
                labels: ['Danger', 'Warning', 'Good', 'Best'],
                datasets: [
                    {
                        label: 'Achievement',
                        data: [25, 25, 25, 25],
                        backgroundColor: [
                            'rgba(255, 26, 104, 1.0)',
                            'rgba(255, 206, 86, 1.0)',
                            'rgba(75, 192, 192, 0.5)',
                            'rgba(75, 192, 192, 1.0)',
                        ],
                        needleValue:80,
                        borderColor: 'white',
                        borderWidth: 1,
                        cutout: '70%', //height slice
                        circumference: 180,
                        rotation: 270,
                        borderRadius: 4,
                    }
                ]
            },

            autoRequestInterval: null // Save interval ID
        }
    },
    computed:{

	},
    watch:{
       // Watcher untuk mendeteksi perubahan status auto request
        autoRequestActive(newValue) {
            if (newValue) {
                this.startAutoRequest();
            } else {
                this.stopAutoRequest();
            }
        },
        // Watcher untuk mendeteksi perubahan interval durasi
        intervalDuration(newValue) {
            if (this.autoRequestActive) {
                this.updateInterval();
            }
        }
    },
    mounted() {
        //this.$emit('childrenRoute');
		//this.hideNonChildren();
        //this.getData();
        if (this.autoRequestActive) {
            this.startAutoRequest();
        } else {
            this.loading.table = false; // Jika tidak aktif, langsung sembunyikan loading
        }
    },
    beforeDestroy() {
        // Stop interval when component destroyed
        if (this.autoRequestInterval) {
            clearInterval(this.autoRequestInterval);
        }
    },
    methods:{
        hideNonChildren() {
            this.isChildRoute = this.$route.path !== '/business-tracking/sales-tracking';
        },

        async getData() {
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams += '/v1/businesstracking/overviewachievement?'

            this.urlRequestParams += '&year='+this.year
			this.urlRequestParams += '&month='+this.month
			this.urlRequestParams += '&area='+this.area

            //this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					this.loading.isSuccess = true;
					this.reportdata = response.data;
                    this.titlemonth = this.getMonthName(this.reportdata?.data?.month ?? this.month);
                    this.titleyear = this.reportdata?.data?.year;

                    this.piechartdata = {
                        cashnoncash: this.setPieChart(this.reportdata?.data?.cash_non_cash ?? []),
                        productgroup: this.setPieChartFuel(this.reportdata?.data?.product_group ?? []),
                        businesscontribution: this.setPieChart(this.reportdata?.data?.business_contribution ?? []),
                    };

                    this.barchartdata = {
                        yoyrevenue: this.setBarchart(this.reportdata?.data?.yoy_revenue ?? []),
                        yoyvolume: this.setBarchart(this.reportdata?.data?.yoy_volume ?? []),
                    };

				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})
        },

        setBarchart(data) {
            //console.log('this.maindata: ' + JSON.stringify(this.maindata))
            let label = 'Label'
            let value = 'Value'
            let legend = 'Legend'
            return this.processBarChart(data, legend, '', value, false, label, "", 1, 2, AppColors, false, false, false, this.stacked);
        },
        setPieChart(data) {
            let item = data;
            let warna = [];
            let defaultcolors = this.chartcolors; //colors ? AppColors : this.chartcolors;
            //console.log('JSON: ' + AppColors);
            let value = [];
            let idx = 0;
            for (var row in item) {
                //add color
                warna[item[row].Label] = defaultcolors[idx] //Rainbow[idx];//'#FFB22E'

                //add value
                let main = {
                    transtype: item[row].Label,
                    amount: item[row].Value,
                };

                value.push(main);
                idx++;
            }

            let result = this.processPieChart(value, "amount", "transtype", 1, 2, warna);
            //console.log('result: ' + JSON.stringify(result))
            //console.log('groupedArray: ' + JSON.stringify(groupedArray));
            //this.piechartdata = result

            return result
        },

        setPieChartFuel(data) {
            let item = data;
            let warna = [];
            //let defaultcolors = colors ? AppColors : this.chartcolors;
            //console.log('JSON: ' + AppColors);
            let value = [];
            let idx = 0;
            for (var row in item) {
                //add color
                warna[item[row].Label] = FuelColor[item[row].Label] //Rainbow[idx];//'#FFB22E'

                //add value
                let main = {
                    transtype: item[row].Label,
                    amount: item[row].Value,
                };

                value.push(main);
                idx++;
            }

            let result = this.processPieChart(value, "amount", "transtype", 1, 2, warna);
            //console.log('result: ' + JSON.stringify(result))
            //console.log('groupedArray: ' + JSON.stringify(groupedArray));
            //this.piechartdata = result

            return result
        },
        needleValue(val) {
            let result = 0;
            if(val >= 100)
                result = 100
            else if(val >= 0)
                result = this.formatNum(val);

            return result;
        },

        gotoPage(page) {
			const urlWithParams = `${window.location.origin}`;
            if(page == 'value')
                window.open(`${urlWithParams}/business-tracking/sales-tracking/value`, '_blank');
            else if(page == 'volume')
                window.open(`${urlWithParams}/finance/pl-unit/volume-real-vs-rkap`, '_blank');
            else if(page == 'spd')
                window.open(`${urlWithParams}/business-tracking/sales-tracking/spd`, '_blank');
		},

        startAutoRequest() {
            if (this.autoRequestInterval) {
                clearInterval(this.autoRequestInterval); // Hentikan interval lama
            }

            this.getData(); // Ambil data pertama kali
            this.autoRequestInterval = setInterval(() => {
                this.getData(); // Ambil data setiap interval
            }, this.intervalDuration * 1000); // Konversi detik ke milidetik
        },

        stopAutoRequest() {
            if (this.autoRequestInterval) {
                clearInterval(this.autoRequestInterval);
                this.autoRequestInterval = null;
            }
        },

        updateInterval() {
            if (this.autoRequestActive) {
                this.stopAutoRequest();
                this.startAutoRequest();
            }
        },

    }
}
</script>

<style>
.card-red{
    background:#FF5757;
    color:#ffffff;
    border-radius:6px;
    padding: 8px 12px;
}

.card-blue{
    background:#4467F8;
    color:#ffffff;
    border-radius:6px;
    padding: 8px 12px;
}

.card-green{
    background:#7ED957;
    color:#ffffff;
    border-radius:6px;
    padding: 8px 12px;
}

.card-cyan{
    background:#38B6FF;
    color:#ffffff;
    border-radius:6px;
    padding: 8px 12px;
}

.font-number {
    font-size:25px;
    font-weight: bold;
}

.icon-size {
    font-size: 35px;
}

.font-title {
    font-weight: bold;
}

.font-subtitle {
    font-size: 14px;
}

.table-sales-tracking-container {
  /*max-width: 500px; */
  width: 100%;
  margin: auto;
  margin-top: 0rem;
  overflow-x: auto;
  height: 480px;
}

.table-sales-tracking {
  font-family: "Open Sans", sans-serif;
  position: relative;
  border-collapse: initial; /**collapse */
  border-spacing: 0;
  table-layout: auto;
  width: 100%;
  border: none;
  border-radius: 0.5rem;
  /*box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);*/
  white-space: nowrap;
}

.table-sales-tracking thead th {
    z-index: 3;
  background: #edf2f7; /* $gray-200 */
  padding: 0.45rem 1.5rem;
  vertical-align: middle;
  text-align: center;
  border: 1px solid white;
  border-left: 0px solid white;
  border-top: 0px solid white;
}

.table-sales-tracking tfoot th {
  background: #edf2f7;  /* $gray-200 */
  padding: 0.45rem 0.5rem;
  vertical-align: middle;
  text-align: right;
  border: 1px solid white;
  border-left: 0px solid #F0F0F0;
  border-top: 0px solid #F0F0F0;
}

.top-header-1 {
    position: -webkit-sticky; /* For Safari */
    position: sticky;
    top: 0;
    z-index: 2;
}

.top-header-2 {
    position: -webkit-sticky; /* For Safari */
    position: sticky;
    top: 70;
    z-index: 2;
}

.table-sales-tracking thead th:first-child {
    z-index: 4;
}

.table-sales-tracking th:first-child {
  border-top-left-radius: 0.5rem;
}

.table-sales-tracking th:last-child {
  border-top-right-radius: 0.5rem;
}


.table-sales-tracking thead tr {
  color: #2d3748; /* $gray-800 */
  font-size: 1rem;
  font-weight: 500;
  text-align: left;
}

.table-sales-tracking tbody tr:nth-child(odd) td {
  background: #ffffff; /* $white */
}

.table-sales-tracking tbody tr:nth-child(even) td {
  background: #FAFBFC /*#edf2f7*/; /* $gray-200 */
}

.table-sales-tracking tbody tr:hover {
  background-color: #e2e8f0 !important; /**e2e8f0 */
}

.table-sales-tracking tbody tr:hover td {
  background-color: #e2e8f0;
}

.table-sales-tracking tbody td {
  color: #1a202c; /* $gray-900 */
  text-align: left;
  padding: 0.4rem 0.5rem;
  vertical-align: middle;
  font-size: 0.925rem;
  font-weight: normal;
  border:1px solid #F0F0F0;
  border-left:0px solid #F0F0F0;
}

.table-sales-tracking tr:last-child td:first-child {
  border-bottom-left-radius: 0.5rem;
}

.table-sales-tracking tr:last-child td:last-child {
  border-bottom-right-radius: 0.5rem;
}

.table-sales-tracking tr > th:first-child,
.table-sales-tracking tr > td:first-child {
  position: sticky;
  left: 0;
}

.table-sales-tracking tr > th:nth-child(2),
.table-sales-tracking tr > td:nth-child(2) {
    /*
  position: sticky;
  left: 63px;
  */
}



</style>
